import { render, staticRenderFns } from "./NextButton.vue?vue&type=template&id=2625eaf8"
import script from "./NextButton.vue?vue&type=script&lang=ts"
export * from "./NextButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports